import { PaletteOptions } from '@mui/material/styles';
import { ThemeBranding } from './types';

export const createPalette = (settings: ThemeBranding): PaletteOptions => ({
  // Brand-driven: white-label apps set these via ApplicationSettings.
  primary: {
    main: settings.primaryButtonColor,
  },
  secondary: {
    main: settings.primaryButtonHoverColor,
  },
  // Semantic colors: fixed, accessible defaults (NOT brand-derived) so
  // error/warning/info/success render consistently across all brands.
  error: {
    main: "#d32f2f",
    light: "#ef5350",
    lighter: "#ffebee",
    dark: "#c62828",
    contrastText: "#ffffff",
  },
  warning: {
    main: "#ed6c02",
    light: "#ff9800",
    lighter: "#fff3e0",
    dark: "#e65100",
    contrastText: "#ffffff",
  },
  info: {
    main: "#0288d1",
    light: "#03a9f4",
    lighter: "#e3f2fd",
    dark: "#01579b",
    contrastText: "#ffffff",
  },
  success: {
    main: "#2e7d32",
    light: "#4caf50",
    lighter: "#e8f5e9",
    dark: "#1b5e20",
    contrastText: "#ffffff",
  },
  text: {
    primary: "rgba(0, 0, 0, 0.87)",
    secondary: "rgba(0, 0, 0, 0.6)",
    disabled: "rgba(0, 0, 0, 0.38)",
  },
  background: {
    default: "#ffffff",
    paper: "#ffffff",
    messageBubble: "#e9e9eb",
  },
  divider: "rgba(0, 0, 0, 0.12)",
  grey: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
  },
});
